import { newProgramMap } from "@saberhq/anchor-contrib";
import { SolanaAugmentedProvider } from "@saberhq/solana-contrib";
import { SABER_ADDRESSES, SABER_IDLS } from ".";
import { RedeemerWrapper } from "./redeemer/wrapper";
import { Router } from "./router";
import { MintProxyWrapper } from "./wrappers";
import { LockupWrapper } from "./wrappers/lockup";
/**
 * Saber SDK.
 */
export class Saber {
    constructor(provider, programs) {
        this.provider = provider;
        this.programs = programs;
        this.router = new Router(provider, programs);
    }
    /**
     * Creates a new instance of the SDK with the given keypair.
     */
    withSigner(signer) {
        return Saber.load({
            provider: this.provider.withSigner(signer),
        });
    }
    /**
     * Mint proxy helpers.
     */
    get mintProxy() {
        return new MintProxyWrapper(this);
    }
    /**
     * Lockup helpers.
     */
    get lockup() {
        return new LockupWrapper(this);
    }
    /**
     * Constructs a new transaction envelope.
     * @param instructions
     * @param signers
     * @returns
     */
    newTx(instructions, signers) {
        return this.provider.newTX(instructions, signers);
    }
    async loadRedeemer(ctorArgs) {
        return await RedeemerWrapper.load({ ...ctorArgs, sdk: this });
    }
    async createRedeemer(ctorArgs) {
        return await RedeemerWrapper.createRedeemer({ ...ctorArgs, sdk: this });
    }
    /**
     * Loads the SDK.
     * @returns
     */
    static load({ provider, }) {
        const programs = newProgramMap(provider, SABER_IDLS, SABER_ADDRESSES);
        return new Saber(new SolanaAugmentedProvider(provider), programs);
    }
}
//# sourceMappingURL=sdk.js.map